import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { TermsAndConditionsListComponent } from './terms-conditions-list.component';

const routes: Routes = [
  { path: '', component: TermsAndConditionsListComponent, data: { title: 'Terms & Conditions' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TermsConditionsListRoutingModule {}

@NgModule({
  imports: [
    TermsConditionsListRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [TermsAndConditionsListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TermsConditionsListModule {}
